//App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ForgotPassword from './components/Auth/ForgotPassword';
import Navigation from './components/navigation/Navigation';
import Logout from './components/Auth/Logout';
import HomePage from './components/Home/HomePage';
import { Container } from 'react-bootstrap';
import Footer from './components/Footer/Footer';
import './App.css';
import ContactUs from './components/ContactUs/ContactUs';
import QueryForm from './components/QueryForm/QueryForm';
import Compliance from './components/Legal/Compliance';
import LegalPage from './components/Legal/LegalPage';
// Import Admin components
import AdminPage from './components/Admin/AdminPage';
import AdminRoute from './components/Admin/AdminRoute';
import AdminComplaints from './components/Admin/AdminComplaints';
// Dashboard section imports
import DashboardLayout from './components/Dashboard/DashboardLayout';
import ReportsTab from './components/Dashboard/ReportsTab';
import MarketOverviewTab from './components/Dashboard/MarketOverviewTab';
import AIChat from './components/AIChat/AIChat';
import MarketWrapPage from './components/MarketWrap/MarketWrapPage';
import PortfolioPage from './components/Portfolio/PortfolioPage';
import MobileTopBar from './components/navigation/MobileTopBar';
import MobileBottomNav from './components/navigation/MobileBottomNav';
import DatabaseEnvBadge from './components/common/DatabaseEnvBadge';
import PageTitle from './components/common/PageTitle';



function App() {
    return (
        <AuthProvider>
            <Router>
                {/* Skip link (audit round-2, WCAG 2.4.1) — first focusable element,
                    targets the id="main-content" landmark in every layout shell */}
                <a href="#main-content" className="skip-link">Skip to main content</a>
                <PageTitle />
                <DatabaseEnvBadge />
                <MobileTopBar />
                <MobileBottomNav />
                <Routes>
                    {/* Routes without Navigation and Footer */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/query" element={<QueryForm />} />
                    

                    {/* Routes with Navigation and Footer */}
                    <Route element={<><Navigation /><main id="main-content"><Outlet /></main><Container className='mw-100 p-0'><Footer /></Container></>}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/contact" element={<ContactUs />} />
                        <Route path="/compliance" element={<Compliance />} />
                        {/* Unified legal page */}
                        <Route path="/legal" element={<LegalPage />} />
                        {/* Legacy routes — redirect to unified legal page with anchor */}
                        <Route path="/disclaimer"           element={<Navigate to="/legal#disclaimer"           replace />} />
                        <Route path="/disclosure"           element={<Navigate to="/legal#disclosure"           replace />} />
                        <Route path="/investor-charter"     element={<Navigate to="/legal#investor-charter"     replace />} />
                        <Route path="/complaints-data"      element={<Navigate to="/legal#complaints-data"      replace />} />
                        <Route path="/news-policy"          element={<Navigate to="/legal#news-policy"          replace />} />
                        <Route path="/refund-policy"        element={<Navigate to="/legal#refund-policy"        replace />} />
                        <Route path="/privacy-policy"       element={<Navigate to="/legal#privacy-policy"       replace />} />
                        <Route path="/terms-and-conditions" element={<Navigate to="/legal#terms-and-conditions" replace />} />
                        <Route element={<AdminRoute />}>
                           <Route path="/admin" element={<AdminPage />} />
                           <Route path="/admin/complaints" element={<AdminComplaints />} />
                        </Route>
                    </Route>

                    {/* Dashboard routes with DashboardLayout and nested routes */}
                    <Route path="/dashboard/*" element={<DashboardLayout />}>
                        <Route path="reports" element={<ReportsTab />} />
                        <Route path="market-overview" element={<MarketOverviewTab />} />
                        <Route path="ai-assistant" element={<AIChat />} />
                        <Route path="market-wrap" element={<MarketWrapPage />} />
                        <Route path="portfolio"   element={<PortfolioPage />} />
                        <Route path="compliance" element={<Compliance />} />
                        <Route element={<AdminRoute />}>
                            <Route path="admin" element={<AdminPage />} />
                        </Route>
                        <Route index element={<Navigate to="reports" replace />} />
                    </Route>

                    {/* Catch-all Route */}
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
